var React = require('react');
var PropTypes = React.PropTypes;
import AttemptRes from '../../resources/attempt';
var moment = require('moment');
import { Link } from 'react-router';
import Auth from '../../resources/auth';
import ConceptRes from '../../resources/concept';

var StudentClassRes = require('../../resources/studentclass');

import Helpers from '../../utils/helpers';
import '../../css/components/Collections/collections.css';
import CircularProgress from 'material-ui/CircularProgress';
import { Pager } from 'react-bootstrap';

var TEACHER_STATUSES = [{
  title: 'New',
  value: ['to_be_marked'],
  actions: ['view', 'mark'],
  count: '-',
  canApplyAdminMode: true
},{
  title: 'In Progress',
  value: ['marking'],
  actions: ['view', 'continue-mark'],
  count: '-'
}, {
  title: 'Finished',
  value: ['scored'],
  actions: ['view'],
  count: '-'
}]

var ADMIN_STATUSES = [{
  title: 'New',
  value: ['to_be_marked'],
  actions: ['view'],
  count: '-'
},{
  title: 'In Progress',
  value: ['marking'],
  actions: ['view'],
  count: '-',
  inChargeCol: true
},{
  title: 'Finished',
  value: ['scored'],
  actions: ['view'],
  count: '-',
  inChargeCol: true
}]

var ITEM_LIMIT = 20;

var MarkingManagement = React.createClass({
  actionByType: function(type, data) {
    var _this = this;
    var result;
    type = type.toLowerCase();

    switch(type) {
      case 'view':
        result = <Link to={"/view-submission/" + data._id}><button className="btn"><i className="fa fa-eye"></i>View</button></Link>;
        break;
      case 'mark':
        result = <Link to={"marking/" + data._id}><button className="btn primary"><i className="fa fa-play"></i>Mark</button></Link>;
        break;
      case 'continue-mark':
        result = <Link to={"marking/" + data._id}><button className="btn secondary"><i className="fa fa-arrow-right"></i>Continue</button></Link>;
        break;
      default:
        result = null;
    }
    return result;
  },

  retrieveAllMyStudents: function(type, callback) {
    
    callback = callback || function(){};
    var _this = this;
    var currentPager = this.state.currentPager;
    var options = {};
    options.skip = ITEM_LIMIT * (currentPager - 1);
    options.limit = ITEM_LIMIT;
    // options.sort = this.state.sort || "dateCreated";
    options.conditions = {};
    // options.conditions.status = {
    //   "$in": this.state.currentMode.value
    // }
    // if (!this.state.currentMode.canApplyAdminRole) {
    //   options.conditions.creator = Auth.getCurrentUser()._id;
    // }
    // if (this.state.currentMode.include) {
    //   options.include = this.state.currentMode.include;
    //   options.includeConditions = includeConditions[options.include];
    // }
          // console.log("state of mdoe is " + this.state.currentMode.cols);
    
    //to ensure that this teacher only sees the classes he/she created
    var currentUser = Auth.getCurrentUser();
    // if (currentUser.status && currentUser.status.indexOf('teacher') >= 0) {

    options.conditions.teacherID = currentUser._id;
    
    // } else if (currentUser.status && currentUser.status.indexOf('admin') >= 0) {

      // options.conditions.ifAdmin = 'true';
    // }

    console.log("TYPE IS " + type);
    
    var scName = '';
    // if (studentClassName) { scName = studentClassName; }

    // console.log("NEW SORT IS " + this.state.sort);
    options.conditions.sort = this.state.sort || "studentClassLevel";
    // options.conditions.status = 'student';
    // options.conditions.studentClassName = scName;
    // options.conditions.lastName = lastN;
    StudentClassRes.retrieveAllStudentsInMyClasses(options, function(err, res) {
      // console.log("BEFORE DON sdfdsfsE!!");
      // console.log(res);

      // if (callback) return callback(err, res);
      // console.log("BEFORE DONE!!");
      _this.setState({
        isLoading: false,
        studentsInMyClassesData: (!err && res) ? res: [{}]
      }, () => {


        _this.countAttemptsInAllModes(type);



        //get attempts after getting all students in my classes-----------------------------------------------------------


        
        var attemptOptions = {};
        attemptOptions.skip = ITEM_LIMIT * (currentPager - 1);
        attemptOptions.limit = ITEM_LIMIT;
        attemptOptions.sort = _this.state.sort || "-dateScored";
        attemptOptions.conditions = {};

        // options for long structure (params.type = practice) 
        attemptOptions.conditions.status = {
          "$in": _this.state.currentMode.value
        }
        attemptOptions.conditions.questionTypes = {
          "$in": [22]
        }
        if (currentUser.status.indexOf('admin') < 0 && !_this.state.currentMode.canApplyAdminMode) {
          attemptOptions.conditions.metadata = {
            marker: currentUser._id
          }
        }

        attemptOptions.conditions.type = 'PRACTICE';

        // options for mock-exam (params.type = exam)
        if (type !== 'practice') {
          attemptOptions.conditions.questionTypes= [];
          attemptOptions.conditions.type = 'MOCK_EXAM';
        }



        AttemptRes.retrieveAttempts(attemptOptions, function(err, response) {

          //loop through each attempt and check if it is from a student in the classes by this teacher
          console.log(response);
          var resLength = response.length;

          var finalAttemptList = [];
          for (var i = 0; i < resLength; i++) { //go through each attempt and check if it is an attempt of a student in this teacher's all classes
          
            var item = response[i];

            var sData = _this.state.studentsInMyClassesData;

            if (sData!=null) {
              
              var sLength = sData.length;
              var ifFound = 0;
              for (var x = 0; x < sLength; x++) { //go through all the student IDs in this teacher's classes

                var thisStudentID = sData[x];

                // console.log("THIS TEACHER's student is : " + thisStudentID);
                // console.log("AND WE ARE CHECKING FOR : " + item["user"]);

                if (thisStudentID == item["user"]) { //if this is indeed a student of this teacher, add this attempt to the final list

                  // console.log("FOUND ATTEMPT BY STUDENT! ADDING TO FINAL LIST!");

                  finalAttemptList.push(item);
                  ifFound = 1;
                  x = sLength; 
                }
                //now check if this 
                // console.log(thisData);
              }
            }
            
          }



          _this.setState({
            attempts: (!err && finalAttemptList) ? finalAttemptList : [],
            // attempts: (!err && res) ? res : [],
            isLoading: false
          }, function() {
            return callback(err, response)
          })
        })


        //--------------------------------------------------------------------------------

        // var sData = _this.state.studentsInMyClassesData;
        // for (var i = 0; i < sData.length; i++) {

        //   var thisData = sData[i];
        //   console.log(thisData);
        //   // var dDate = thisData['dateCreated'];
        //   // var processDate = new Date(dDate);
        //   // var dateToDisplay = processDate.toDateString();
        //   // if (processDate.getFullYear()=='1970') { dateToDisplay = '-';}
        //   // thisData['dateCreated'] = dateToDisplay;//processDate.getFullYear() + "/" + processDate.getMonth() + "/" + processDate.getDate();
        // }

        // _this.setState({
        //   studentClassesData: sData
        // });
      }
      // , function() {
        // _this.retrieveCollectionQuestionStat(function() {
          // if (_this.state.currentMode.showReviewStat) {
          //   var collections = _this.state.collectionData;
          //   for (var i = 0; i < collections.length; i++) {
          //     _this.retrieveCollectionTaskStat(collections[i]);
          //   }
          // }
        // });
        // return callback(err, res);
      // }
      );
    })
  },

  retrieveMarkingAttempts: function(type, callback) {
    callback = callback || function(){};
    var _this = this;
    var currentPager = this.state.currentPager;
    var currentUser = Auth.getCurrentUser();
    var options = {};
    options.skip = ITEM_LIMIT * (currentPager - 1);
    options.limit = ITEM_LIMIT;
    options.sort = this.state.sort || "-dateScored";
    options.conditions = {};

    // options for long structure (params.type = practice) 
    options.conditions.status = {
      "$in": this.state.currentMode.value
    }
    options.conditions.questionTypes = {
      "$in": [22]
    }
    if (currentUser.status.indexOf('admin') < 0 && !this.state.currentMode.canApplyAdminMode) {
      options.conditions.metadata = {
        marker: currentUser._id
      }
    }

    options.conditions.type = 'PRACTICE';

    // options for mock-exam (params.type = exam)
    if (type !== 'practice') {
      options.conditions.questionTypes= [];
      options.conditions.type = 'MOCK_EXAM';
    }

    this.retrieveAllMyStudents(type);

    // AttemptRes.retrieveAttempts(options, function(err, res) {

    //   //loop through each attempt and check if it is from a student in the classes by this teacher
    //   console.log("");
    //   var resLength = res.length;

    //   var finalAttemptList = [];
    //   for (var i = 0; i < resLength; i++) { //go through each attempt and check if it is an attempt of a student in this teacher's all classes
      
    //     var item = res[i];

    //     var sData = _this.state.studentsInMyClassesData;

    //     if (sData!=null) {
          
    //       var sLength = sData.length;
    //       var ifFound = 0;
    //       for (var x = 0; x < sLength; x++) { //go through all the student IDs in this teacher's classes

    //         var thisStudentID = sData[x];

    //         console.log("THIS TEACHER's student is : " + thisStudentID);
    //         console.log("AND WE ARE CHECKING FOR : " + item["user"]);

    //         if (thisStudentID == item["user"]) { //if this is indeed a student of this teacher, add this attempt to the final list

    //           console.log("FOUND ATTEMPT BY STUDENT! ADDING TO FINAL LIST!");

    //           finalAttemptList.push(item);
    //           ifFound = 1;
    //           x = sLength; 
    //         }
    //         //now check if this 
    //         // console.log(thisData);
    //       }
    //     }
        
    //   }


    //   _this.setState({
    //     attempts: (!err && finalAttemptList) ? finalAttemptList : [],
    //     // attempts: (!err && res) ? res : [],
    //     isLoading: false
    //   }, function() {
    //     return callback(err, res)
    //   })
    // })
  },

  changeStatusMode: function(mode) {
    this.setState({
      currentMode: mode,
      attempts: [],
      isLoading: true,
      currentPager: 1
    }, function() {
      var type = this.props.params.type;
      this.retrieveMarkingAttempts(type);
    });
  },

  countAttemptsInMode: function(mode, type, callback) {
    var _this = this;
    callback = callback || function(){};
    mode.count = '-';

    var conditions = {
      status: {
        "$in": mode.value
      },
      questionTypes: {
        "$in": [22]
      }
    }

    conditions.type = 'PRACTICE';

    // conditions for counting mock-exams (params.type = exam)
    if (type !== 'practice') {
      conditions.type = 'MOCK_EXAM';
      delete conditions.questionTypes;
    }

    var currentUser = Auth.getCurrentUser();
    if (currentUser.status.indexOf('admin') < 0 && !mode.canApplyAdminMode) {
      conditions.metadata = {marker: currentUser._id};
    }

    AttemptRes.countAttempt(conditions, function(err, res) {

      if (!err && res) {

        //now we check the returned attempts here against the students of this teachers we have to count how many submissions
        var finalAttemptList = [];
        var foundSubmissions = 0;
        // console.log("RES FOR COUNT IS AS BELOWS:");
        // console.log(res);
        var resObject = res.count;
        var resLength = resObject.length;
        var sData = _this.state.studentsInMyClassesData;
        // console.log("STUDENTS IN CLASS DATA S FOLLOWS:");
        // console.log(sData);
        var sLength = sData.length;

        // console.log("THERE ARE " + resLength + " submissions to check through!");
        // console.log("THERE ARE " + sLength + " students!");


        for (var i = 0; i < resLength; i++) { //go through each attempt and check if it is an attempt of a student in this teacher's all classes


          var item = resObject[i];
          // console.log("AND WE ARE CHECKING FOR : " + item["user"]);

          if (sLength > 0) {
            
            var ifFound = 0;
            for (var x = 0; x < sLength; x++) { //go through all the student IDs in this teacher's classes

              var thisStudentID = sData[x];

              // console.log("THIS TEACHER's student is : " + thisStudentID);

              if (thisStudentID == item["user"]) { //if this is indeed a student of this teacher, add this attempt to the final list

                // console.log("FOUND ATTEMPT BY STUDENT! ADDING TO FINAL LIST!");

                finalAttemptList.push(item);
                foundSubmissions++;
                ifFound = 1;
                x = sLength; 
              }
              //now check if this 
              // console.log(thisData);
            }
          }
          
        }

        mode.count = foundSubmissions;//finalAttemptList.length;//res.count;
      }
      else mode.count = 'No data';
      return callback();
    })
  },

  countAttemptsInAllModes: function(type) {
    var _this = this;
    var statusMode = this.state.statusMode;
    var count = statusMode.length;
    console.log("THERE ARE " + count + " STATUS MODE");
    
    for (var i = 0; i < count; i++) {
      _this.countAttemptsInMode(statusMode[i], type, function() {
        count--;
        if (count <= 0) _this.forceUpdate();
      });
    }
  },

  retrieveConceptsMap: function(callback) {
    callback = callback || function(){};
    var _this = this;
    ConceptRes.retrieveAllConceptsMap(function(err, conceptsMap) {
      _this.setState({
        conceptsMap: conceptsMap
      })
      return callback(err, conceptsMap);
    })
  },

  retrieveUserCourses: function(callback) {
    callback = callback || function(){};
    var _this = this;
    ConceptRes.retrieveUserCourses(function(err, courses) {

      var coursesObj = {};

      for (var i = 0; i < courses.length; i++) {
        coursesObj[courses[i]._id] = courses[i];
      }

      _this.setState({
        userCourses: coursesObj
      })
      return callback(err, courses);
    })
  },

  getCourseName: function(courseId) {
    return this.state.userCourses && this.state.userCourses[courseId] ? this.state.userCourses[courseId].title : "No Subject";
  },

  navigatePager: function(dir) {
    var currentPager = this.state.currentPager,
        _this = this;
    currentPager += dir;
    _this.setState({
      currentPager: currentPager,
      isLoading: true,
      attempts: []
    }, () => {
      var type = this.props.params.type;
      this.retrieveMarkingAttempts(type);
    })
  },

  changeSort: function(chosenSort) {
    var newSort;
    if (this.state.sort.indexOf(chosenSort) >= 0) {
      var sort = this.state.sort;
      if (sort.charAt(0) === '-') newSort = sort.substr(1, sort.length);
      else newSort = '-'  + sort;
    } else {
      newSort = '-' + chosenSort;
    }
    this.setState({
      sort: newSort,
      attempts: [],
      isLoading: true,
      currentPager: 1
    }, () => {
      var type = this.props.params.type;
      this.retrieveMarkingAttempts(type);
    })
  },

  getInitialState: function() {
    return {
      attempts: [],
      isLoading: false,
      statusMode: [],
      currentMode: {},
      currentPager: 1,
      conceptsMap: null,
      sort: '-dateScored'
    };
  },

  render: function() {
    var _this = this,
        ascSortIcon = <span className="fa fa-caret-up padding-left-5"></span>,
        descSortIcon = <span className="fa fa-caret-down padding-left-5"></span>,
        sortIcon = <span className="fa fa-sort padding-left-5"></span>,
        sort = this.state.sort;
    function getSortIcon(currentSort) {
      if (sort.indexOf(currentSort) >= 0) {
        if (sort.charAt(0) === '-') return descSortIcon;
        else return ascSortIcon;
      } else {
        return sortIcon;
      }
    }

    return (
      <div className="collections">
          <div className="content-toolbar">
            <h3>Submissions</h3>
          </div>
          <div style={{"border": "1px solid #ddd", "padding": "10px"}}>
            <div className="collection-statuses">
              <div className="dp-table" style={{"tableLayout": "fixed", "width": "100%"}}>
                {
                  this.state.statusMode.map(function(mode, index) {
                    return (
                      <div
                        key={index}
                        className={"dp-table-cell cell " + (_this.state.currentMode === mode ? 'active' : '')}
                        onClick={_this.changeStatusMode.bind(_this, mode)}>
                        {mode.title + ' (' + mode.count + ')'}
                      </div>
                    )
                  })
                }
              </div>
            </div>
            <hr/>
            <div className="collection-table">
              <table className="table table-bordered table-striped">
                <thead>
                  {
                    _this.props.params.type === 'practice' &&
                    <tr>
                      <th className="sortable" onClick={this.changeSort.bind(this, 'creatorName')}>
                        Student Name
                        {getSortIcon('creatorName')}
                      </th>
                      <th>Subject</th>
                      <th>Concept</th>
                      <th className="sortable" onClick={this.changeSort.bind(this, 'dateScored')}>
                        Submitted on
                        {getSortIcon('dateScored')}
                      </th>
                      {
                        _this.state.currentMode.inChargeCol &&
                        <th className="sortable" onClick={this.changeSort.bind(this, 'metadata.markerName')}>
                          In charge
                          {getSortIcon('metadata.markerName')}
                        </th>
                      }
                      <th>Actions</th>
                    </tr>
                  }  
                  {
                    _this.props.params.type !== 'practice' &&
                    <tr>
                      <th>Parent's mail</th>
                        <th className="sortable" onClick={this.changeSort.bind(this, 'userName')}>
                        Student Name
                        {getSortIcon('userName')}
                      </th>
                      <th>Subject</th>
                      <th className="sortable" onClick={this.changeSort.bind(this, 'dateScored')}>
                        Submitted on
                        {getSortIcon('dateScored')}
                      </th>
                      {
                        _this.state.currentMode.inChargeCol &&
                        <th className="sortable" onClick={this.changeSort.bind(this, 'metadata.markerName')}>
                          In charge
                          {getSortIcon('metadata.markerName')}
                        </th>
                      }
                      <th>Actions</th>
                    </tr>
                  }
                </thead>
                <tbody>
                  {
                     _this.props.params.type === 'practice' &&
                    _this.state.attempts.map(function(attempt, index) {
                      return (
                        <tr key={index}>
                          <td>{attempt.creatorName}</td>
                          <td>
                            {_this.getCourseName(attempt.course)}
                          </td>
                          <td>
                            {attempt.concepts[0] && _this.state.conceptsMap && _this.state.conceptsMap[attempt.concepts[0]] ? _this.state.conceptsMap[attempt.concepts[0]].title : "No Concept"}
                          </td>
                          <td>{moment(attempt.dateScored).format("MM/DD/YYYY hh:mm A")}</td>
                          {
                            _this.state.currentMode.inChargeCol &&
                            <td>{attempt.metadata.markerName}</td>
                          }
                          <td className="action">
                            {
                              _this.state.currentMode.actions.map(function(action, index) {
                                return (
                                  <div key={index} className="dp-inline-block">
                                    {_this.actionByType(action, attempt)}
                                  </div>
                                )
                              })
                            }
                          </td>
                        </tr>
                      )
                    })
                  }
                  {
                    _this.props.params.type !== 'practice' && _this.state &&
                    _this.state.attempts.map(function(attempt, index) {
                      return (
                        <tr key={index}>
                          <td>{attempt.creatorInfo && attempt.creatorInfo.targetRoles.length > 0 ? attempt.creatorInfo.targetRoles[0].userInfo.email : 'No parent'}</td>
                          <td>{attempt.userName}</td>
                          <td>
                            {_this.getCourseName(attempt.course)}
                          </td>
                          <td>{moment(attempt.dateScored).format("MM/DD/YYYY hh:mm A")}</td>
                          {
                            _this.state.currentMode.inChargeCol &&
                            <td>{attempt.metadata.markerName}</td>
                          }
                          <td className="action">
                            {
                              _this.state.currentMode.actions.map(function(action, index) {
                                return (
                                  <div key={index} className="dp-inline-block">
                                    {_this.actionByType(action, attempt)}
                                  </div>
                                )
                              })
                            }
                          </td>
                        </tr>
                      )
                    })
                  }
                </tbody>
              </table>
            </div>
          {
            _this.state.isLoading &&
            <CircularProgress />
          }
          <Pager>
            {
              _this.state.currentPager > 1 &&
              <Pager.Item
                onClick={_this.navigatePager.bind(_this, -1)}
                disabled={_this.state.currentPager === 1}
              >
                Previous
              </Pager.Item>
            }
            {' '}
            {
              _this.state.attempts.length >= ITEM_LIMIT &&
              <Pager.Item
                onClick={_this.navigatePager.bind(_this, 1)}
                disabled={_this.state.attempts.length < ITEM_LIMIT}
              >
                Next
              </Pager.Item>
            }
          </Pager>
        </div>
      </div>
    );
  },

  componentWillReceiveProps: function(nextProps) {
    this.setState({
      isLoading: true,
      currentMode: this.state.statusMode[0]
    }, function(){
      this.retrieveMarkingAttempts(nextProps.params.type);
      this.countAttemptsInAllModes(nextProps.params.type);
    })
  },

  componentDidMount: function() {
    var _this = this;
    var currentUser = Auth.getCurrentUser();
    var statusMode = this.state.statusMode;
    var type = this.props.params.type;
    if (currentUser.status.indexOf('admin') >= 0) {
      statusMode = ADMIN_STATUSES;
    } else {
      statusMode = TEACHER_STATUSES;
    }
    this.setState({
      isLoading: true,
      statusMode: statusMode,
      currentMode: statusMode[0]
    }, function(){
      // this.countAttemptsInAllModes(type);
      // this.retrieveAllMyStudents();
      this.retrieveMarkingAttempts(type);
      // this.countAttemptsInAllModes(type);
      this.retrieveUserCourses();
      this.retrieveConceptsMap();
    })
  },

});

module.exports = MarkingManagement;



/** WEBPACK FOOTER **
 ** ./src/components/Marking/MarkingManagement.js
 **/